import { render, staticRenderFns } from "./ModifyArticle.vue?vue&type=template&id=07ddd9fe&scoped=true"
import script from "./ModifyArticle.vue?vue&type=script&lang=js"
export * from "./ModifyArticle.vue?vue&type=script&lang=js"
import style0 from "./ModifyArticle.vue?vue&type=style&index=0&id=07ddd9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ddd9fe",
  null
  
)

export default component.exports